



































































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import CommissionLogModule from '@/store/modules/CommissionLog';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import utils from '@/services/utils';
import moment from 'moment';

@Component({
  components: {
    Table,
  },
})
export default class ResetPasswordLog extends Mixins(ErrorHandleMixin) {
  TableHead = [
    [
      {
        displayName: 'securecode.operator',
      },
      {
        displayName: 'securecode.role',
      },
      {
        displayName: 'securecode.user',
      },
      {
        displayName: 'securecode.role',
      },
      {
        displayName: 'securecode.pt_before',
      },
      {
        displayName: 'securecode.pt_after',
      },
      {
        displayName: 'securecode.time',
      },
      {
        displayName: 'securecode.ip',
      },
    ],
  ];

  CommissionLogInstance = getModule(CommissionLogModule, this.$store);

  utilsInstance = utils;

  searchText = '';

  data = [];

  historyPage = 1;

  async fetchResetLog() {
    this.GeneralInstance.toggleLoading(true);
    const { data, status } = await this.CommissionLogInstance.FetchComissionLog({
      username: this.searchText,
    });
    this.checkError(status);
    const dataList = data.list.map((item) => ({
      ...item,
      timestamp: moment(item.timestamp).add(-1, 'h').format('DD/MM/YYYY, hh:mm:ss a'),
    }));
    this.data = dataList;
    this.GeneralInstance.toggleLoading(false);
  }

  onSubmit() {
    this.fetchResetLog();
  }
}
